module.exports = __webpack_public_path__ + "static/media/lenderGrowPlant.d6e87ea4.webp";